export default class SubNav {
    constructor() {
        this.el = document.querySelector("#sub-nav-swiper");
        this.swiper = null;

        this.init();
    }

    init() {
        if (!this.el) return;

        this.swiper = new Swiper(this.el, {
            slidesPerView: "auto",
            spaceBetween: 8,
            navigation: {
                nextEl: this.el.querySelector(".no-sub-nav__button--next"),
                prevEl: this.el.querySelector(".no-sub-nav__button--prev"),
            },
            on: {
                init() {
                    const activeIndex = this.slides.findIndex((slide) =>
                        slide.classList.contains("--active")
                    );

                    if (activeIndex !== -1) {
                        this.slideTo(activeIndex);
                    }

                    const initialIndex = this.slides.findIndex((slide) =>
                        slide.classList.contains("--active")
                    );

                    if (initialIndex !== -1) {
                        this.slideTo(initialIndex);
                    }

                    const initialCarousel = () => {
                        const itemWidth = this.wrapperEl.offsetWidth;
                        const isFirst = window.innerWidth < itemWidth;

                        if (isFirst) {
                            this.el.classList.add("--first");
                        } else {
                            this.el.classList.remove("--first");
                        }
                    };

                    initialCarousel();
                    window.addEventListener("resize", initialCarousel);
                },
            },
            breakpoints: {
                320: {
                    spaceBetween: 8,
                },
                768: {
                    spaceBetween: 16,
                },
            },
        });
    }
}
